import React, { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";
import { MemberBox } from "@logora/parliament.parliament_member.member_box";
import { Label } from "@logora/parliament.ui.label";
import { DossierIcon } from "@logora/parliament.icons.regular_icons";
import { AmendmentIcon } from "@logora/parliament.icons.regular_icons";
import { QuestionIcon } from "@logora/parliament.icons.regular_icons";
import { formatTexteLegislatif } from "../formatters";

const AlertSourceField = ({ targetClass, targetId }) => {
    const [source, setSource] = useState(undefined);
    const [sourceTargetId, setSourceTargetId] = useState(targetId);
    const [sourceTargetClass, setSourceTargetClass] = useState(targetClass);
    const [isLoading, setIsLoading] = useState(false);
    const dataProvider = useDataProvider();

    const getIncludes = (sourceTargetClass) => {
        switch (sourceTargetClass) {
            case "Acteur":
                return ["groupeParlementaire"];
            case "Dossier":
                return [];
            case "Amendement":
                return ["documentRef"];
            default:
                return [];
        }
    };

    useEffect(() => {
        const fetchSource = async () => {
            if (sourceTargetId && sourceTargetClass) {
                try {
                    const response = await dataProvider.getOne(`${sourceTargetClass.toLowerCase()}s`, {
                        id: sourceTargetId,
                        include: getIncludes(sourceTargetClass),
                    });
                    const record = response.data;
                    if (record) {
                        setSource(record);
                        setIsLoading(false);
                    }
                } catch (error) {
                    console.log(error);
                    setIsLoading(false);
                }
            }
        };
        fetchSource();
    }, [sourceTargetId, sourceTargetClass, dataProvider]);

    if (!targetClass || !targetId) {
        return null;
    }

    return (
        <>
            {isLoading && <div>Chargement...</div>}
            {sourceTargetClass === "Acteur" && source && (
                <MemberBox
                    firstName={source.prenom}
                    lastName={source.nom}
                    imageUrl={source.urlImage}
                    parliamentGroup={{
                        groupName: source.groupeParlementaire?.libelleAbrege,
                        color: source.groupeParlementaire?.couleurAssociee,
                    }}
                    chamber={source.chambre}
                    layout="oneLine"
                />
            )}
            {sourceTargetClass === "Dossier" && source && (
                <Label
                    text={`Dossier · ${
                        source.titre.length > 45
                            ? `${source.titre.substring(0, 45)}...`
                            : source.titre
                    }`}
                    leftIcon={<DossierIcon width={18} height={18} />}
                />
            )}
            {sourceTargetClass === "Amendement" && source && (
                <Label
                    text={`Amendement · ${formatTexteLegislatif("documentRef", source)}`}
                    leftIcon={<AmendmentIcon width={18} height={18} />}
                />
            )}
            {sourceTargetClass === "Question" && source && (
                <Label
                    text={`Question · ${
                        source.titre.length > 45
                            ? `${source.titre.substring(0, 45)}...`
                            : source.titre
                    }`}
                    leftIcon={<QuestionIcon width={18} height={18} />}
                />
            )}
        </>
    );
}

export default AlertSourceField;